import * as React from 'react';
import { css, html } from 'react-strict-dom';

import PageWrapPadding from './PageWrapPadding';

const widths = {
  smaller: 620,
  small: 800,
  medium: 1100,
  large: 1300,
} as const;

type Props = Readonly<{
  background?: 'grey' | string;
  limitWidth?: keyof typeof widths;
  /**
   * Set true if you want to build your own segmented padding with PageWrapPadding
   */
  noPadding?: boolean;
  children: React.ReactNode;
}>;

export default function PageWrap({
  background,
  limitWidth,
  noPadding,
  children,
}: Props) {
  return (
    <html.div style={[styles.pageWrap, styles.background(background)]}>
      <PageWrapPadding
        top={!noPadding}
        horizontal={!noPadding}
        bottom={!noPadding}
      >
        <html.div
          style={limitWidth ? styles.limitWidth(limitWidth) : undefined}
        >
          {children}
        </html.div>
      </PageWrapPadding>
    </html.div>
  );
}

const styles = css.create({
  pageWrap: {
    minHeight: '100vh',
    overflow: 'auto',
  },
  background: (value: 'grey' | string | undefined) => ({
    backgroundColor: value === 'grey' ? '#fafafa' : value || '#fff',
  }),
  limitWidth: (value: keyof typeof widths) => ({
    maxWidth: widths[value],
    marginInline: 'auto',
  }),
});
